import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export const usePreviousUrl = () => {
  const location = useLocation();
  const prevLocationRef = useRef();

  useEffect(() => {
    prevLocationRef.current = location.pathname;
  }, [location]);

  return prevLocationRef.current;
};